
import React from 'react'

interface CookieConsentProps {
  onAccept: () => void
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-primary-navy text-white p-4 z-50 border-t-4 border-primary-teal">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
        <p className="text-sm">
          We use basic analytics to improve the site. By continuing, you agree to our use of cookies.
        </p>
        <button
          onClick={onAccept}
          className="bg-primary-teal text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-white hover:text-primary-navy transition-colors whitespace-nowrap"
        >
          Accept
        </button>
      </div>
    </div>
  )
}

export default CookieConsent
